import React from 'react';
import Modal from '../../layouts/Modal/Modal';

export type ActivationSuccessfulModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  imageSrc: string;
};

const ActivationSuccessfulModal: React.FC<ActivationSuccessfulModalProps> = ({ isOpen, onClose, title, imageSrc }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="max-w-460 flex flex-col justify-center items-center p-32 pb-40">
        <img src={imageSrc} alt="success" className="w-80 h-80" />
        <h4 className="mb-12 typo-title-24 text-center">{title}</h4>
      </div>
    </Modal>
  );
};

export default ActivationSuccessfulModal;
